import * as React from "react";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import { TextInput, required } from "react-admin";
import { CoreInfoRequestStatusEnum } from "../../../../Enums/CoreInfoRequestStatusEnum";

interface AdditionalDetailsCardProps {
  record: any;
  classes: any;
  mode: "customer" | "tt";
  // Customer mode states
  dom?: boolean;
  removalReasonDetail?: boolean;
  nha?: boolean;
  nla?: boolean;
  engineSerialNumber?: boolean;
  adSbMod?: boolean;
  validate?: any[];
}

const AdditionalDetailsCard: React.FC<AdditionalDetailsCardProps> = ({
  record,
  classes,
  mode,
  dom,
  removalReasonDetail,
  nha,
  nla,
  engineSerialNumber,
  adSbMod,
  validate = [],
}) => {
  const isCustomerMode = mode === "customer";

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography className={classes.cardTitle}>Additional Details</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextInput
              source="dom"
              label="DOM"
              fullWidth
              validate={isCustomerMode && dom === false ? required() : validate}
              variant="outlined"
              disabled={isCustomerMode ? dom || record.status === CoreInfoRequestStatusEnum.Accepted : true}
              defaultValue={record.dom}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source="removalReasonDetail"
              label="Removal Reason Detail"
              fullWidth
              validate={isCustomerMode && removalReasonDetail === false ? required() : validate}
              variant="outlined"
              disabled={
                isCustomerMode ? removalReasonDetail || record.status === CoreInfoRequestStatusEnum.Accepted : true
              }
              defaultValue={record.removalReasonDetail}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source="nha"
              label="NHA"
              fullWidth
              validate={isCustomerMode && nha === false ? required() : validate}
              variant="outlined"
              disabled={isCustomerMode ? nha || record.status === CoreInfoRequestStatusEnum.Accepted : true}
              defaultValue={record.nha}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source="nla"
              label="NLA"
              fullWidth
              validate={isCustomerMode && nla === false ? required() : validate}
              variant="outlined"
              disabled={isCustomerMode ? nla || record.status === CoreInfoRequestStatusEnum.Accepted : true}
              defaultValue={record.nla}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source="engineSerialNumber"
              label="Engine Serial Number"
              fullWidth
              validate={isCustomerMode && engineSerialNumber === false ? required() : validate}
              variant="outlined"
              disabled={
                isCustomerMode ? engineSerialNumber || record.status === CoreInfoRequestStatusEnum.Accepted : true
              }
              defaultValue={record.engineSerialNumber}
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              source="adSbMod"
              label="AD(SB/MOD)"
              fullWidth
              validate={isCustomerMode && adSbMod === false ? required() : validate}
              variant="outlined"
              disabled={isCustomerMode ? adSbMod || record.status === CoreInfoRequestStatusEnum.Accepted : true}
              defaultValue={record.adSbMod}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AdditionalDetailsCard;
